import React, { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import Table from '../../Table/Table';
import { DupeQAColumns } from '../../Table/TableColumn';
import { tableColumns } from '../../Redux/TableSlice';
import { clearData, updateSearch, searchClicked } from '../../Redux/MNR/DupeQASlice';
import { clearAll } from '../../Redux/CNS/CommonSlice';
import { GeneralError } from '../../Utility/Constants';
import Spinner from '../../Spinner/Spinner';
import { showAll } from '../../Redux/MNR/MNRCommonSlice';

function DupeQA() {
    const dispatch = useDispatch();
    const error = useSelector(state => state.dupeQA.error);
    const loading = useSelector(state => state.dupeQA.loading);
    //const showAllValue = useSelector(state => state.mnrCommon.showAll);
    const showAllValueTable = true;

    useEffect(() => {
        //alert(true)
        dispatch(showAll(true));
    }, [dispatch])

    useEffect(() => {
        if (error) {
            toast.error(GeneralError);
            return;
        }
    }, [error]);

    const handleResetInitial = (useCallback(() => {
        dispatch(clearAll());
        dispatch(clearData());
        dispatch(updateSearch(true));
        dispatch(searchClicked(false));
        //dispatch(showAll(false));
    }, [dispatch]))

    useEffect(() => {
        handleResetInitial();
        dispatch(tableColumns(DupeQAColumns));
    }, [dispatch, handleResetInitial])

    return (
        <>
            {loading && <Spinner />}
            {(showAllValueTable) && <Table />}
        </>
    )
}

export default DupeQA;